import { render, staticRenderFns } from "./EntityDataEmails.vue?vue&type=template&id=7c52fdbc&scoped=true"
import script from "./EntityDataEmails.vue?vue&type=script&lang=js"
export * from "./EntityDataEmails.vue?vue&type=script&lang=js"
import style0 from "./EntityDataEmails.vue?vue&type=style&index=0&id=7c52fdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52fdbc",
  null
  
)

export default component.exports